import React, { useState, useCallback, useEffect, useMemo, useRef } from 'react';
import { IView } from 'Framework';
import { ComponentMapIds } from '../map';
import { toNumber } from 'lodash';
import { strings } from 'src/localization';
import css from './Summary.module.scss';
import cssCards from './SummaryCards.module.scss';
import { ViewMode } from 'src/enums';
import Footer from '../Footer/Footer';
import { VehicleRec, UpdateApptCustInp, UpdateApptDateInp, Advisor, Services, UpdateApptOpsInp, OpType, VehicleStockPhoto, PhotoList, WebOp, MaintenanceMenuRec, Customer, WebOpChecked, VehData, UpdateApptVehInp, MaintenanceContract, DepartmentSpec, DeteremineDeptInp, ApptCust, invalidDates, EmployeeChanges, ascPageviewInput, ascCtaInteractionInput, ascFormEngagementInput, ascFormSubmissionInput, ascFormSubmissionSvcApptInput, ascRetailProcessInput, ascElementConfigurationInput } from 'src/models';
import { IAppointmentState, IServicesState, ISpecsState } from 'src/store/states';
import AppointmentCard from '../AppointmentCard/AppointmentCard';
import ServicesCard from './ServicesCard/ServicesCard';
import VehicleCard from '../VehicleCard/VehicleCard';
import InformationCard from './InformationCard/InformationCard';
import ConfirmationCard from './ConfirmationCard/ConfirmationCard';
import Disclaimer from './Disclaimer/Disclaimer';
import { LoadingProgress, ScrollBar } from '@framework-controls/core';
import ErrorMessage from '../ErrorMessage/ErrorMessage';
import RecordLockError from '../RecordLockError/containers/RecordLockError';
import InformationCardField from './InformationCard/InformationCardField';
import { checkCustUpdateEmail } from 'src/helpers/DepartmentHelper/DepartmentHelper';
import { ascCtaInteraction, ascElementConfiguration, ascFormEngagement, ascFormSubmission, ascFormSubmissionSvcAppt, ascPageview, ascRetailProcess, getElementColor, utagIdentityLink } from 'src/helpers/EventHelper/EventHelper';
import classNames from 'classnames';
import { buildApptData, sendSdEvent, getProviderId } from 'src/helpers/ShiftDigitalHelper/ShiftDigitalHelper';

const emailRegex = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))/.source +
    /@/.source +
    /((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.source);

const phoneRegex = new RegExp(/^(\d{3})(\d{3})(\d{4})$/);
export interface IProps {
    appointment: IAppointmentState;
    specData?: ISpecsState;
    advisors?: Advisor[];
    viewMode?: ViewMode;
    vehiclePhoto: VehicleStockPhoto;
    profile: string;
    store: string;
    branch: string;
    vehPhotoList: PhotoList;
    previewFlag: string;
    theme: string;
    textCheckReturned?: boolean;
    textOptIn?: string;
    gmTrackingFlag: string;
    additionalServices: IServicesState;
    loadAppt: string;
    individualServices: WebOp[];
    menus: MaintenanceMenuRec[];
    custError?: string;
    customerInfo: Customer;
    skipServicesFlag?: boolean;
    itemServiceChecked: WebOpChecked[];
    specProfile: string;
    locale: string;
    profileOpen: boolean;
    selectedVehicle: string,
    newVehicleMileage: string,
    prevMileage: number,
    smsLaunched: string;
    skipServices: boolean;
    maintContracts: MaintenanceContract[];
    apptDept: string;
    invalidDates: invalidDates[];
    invalidDatesDept: string;
    apptAdvNum?: string;
    apptCust?: ApptCust;
    specDeptData: DepartmentSpec;
    lastDeptRan?: string;
    deptChangeFlag: boolean;
    employeeFlag?: boolean;
    vehicles: VehicleRec[];
    gmRedeemAmt: string | undefined;
    gmMemberErr: string;
    gmRewardsLoading: boolean;
    myGMRewardsLaunched: string | undefined;
    gmDealerCanEarn: string | undefined;
    gmDealerCanRedeem: string | undefined;
    Itype: string | undefined;
    TMNAMileage: number;
    mainPaneViewOrder: IView[];
    changeCustReturned: boolean;
    countryCode: string;
    idkMileage: string;
    sessionId: string;
    lexusMCLaunched: string;
    toyotaMCLaunched: string;
    lexusTDMCLaunched: string;
    toyotaTDMCLaunched: string;
    hidePriceLabel?: string;
    pushToMainPanes: (inputView: IView) => void;
    updateApptCust: (inp: UpdateApptCustInp) => void;
    createAppt: (inp: Services[], optIn: boolean, preferContactSelect: string,
        sendConfirmation: string, isOEM: string) => void;
    editAppt: (inp: Services[], optIn: boolean, preferContactSelect: string, sendConfirmation: string) => void;
    updateVehicleMileage: (mileage: number) => void;
    clearError: () => void;
    UpdateApptOps: (inputOps: UpdateApptOpsInp[]) => void;
    toggleMenu: (id: string) => void;
    toggleWeOwe: (id: string) => void;
    toggleRecommended: (id: string) => void;
    toggleRecall: (id: string) => void;
    toggleItem: (id: string) => void;
    getPhoto: (year: string, make: string, model: string, id: string) => void;
    getCustAppts: (custId: string, profile: string, store: string, branch: string) => void;
    checkPhoneOptIn: (custId: string, profileNum: string, store: string, branch: string, phone?: string) => void;
    clearTextCheckReturned: () => void;
    addLogEntry: (action: string, screen: string, details: string) => void;
    ClearTokenData: () => void;
    clearCheckedWebOps: () => void;
    clearCheckedAdditionalServices: () => void;
    clearROState: () => void;
    setScheduleOption: (id: string) => void;
    setMileageOption: (id: string) => void;
    checkUniqueEmail: (email: string, nameId: string, profileNum: string, store: string, branch: string,
        firstName: string, lastName: string, phone: string) => void;
    clearCustError: () => void;
    cancelAppt: () => void;
    getMenus: (value1, value2) => void;
    clearMenusState: () => void;
    getAdditionalServices: (profileNum: string, store: string, branch: string) => void;
    getApptOps: (profileNum: string, store: string, branch: string, vehData?: VehData) => void;
    onApptCustUpdate: (apptCust: UpdateApptCustInp) => void;
    getInvalidDates: (pecProfile: string) => void;
    clearInvalidDates: () => void;
    decodeErr: string | undefined;
    updateApptVeh: (inp: UpdateApptVehInp) => void;
    identityVerified: boolean;
    getDeptSpecs: () => void;
    determineDept: (inp: DeteremineDeptInp) => void;
    getRMTimes: (specProfile: string, selectedDate: string, selectedAdv: string, recallSelected: boolean) => void;
    clearRMTimes: () => void;
    popFromMainPane: (id: string) => void;
    changeDeptFlag: (inp: boolean) => void;
    updateEmployeeChanges: (inp: EmployeeChanges) => void;
    gmMemberSearch: (inp: string) => void;
    changeCustInfo: (customer: Customer, profileNum: string, store: string, branch: string, previewFlag: any) => void;
    setChangeCustReturned: (inp: boolean) => void;
    clearOnlyAppointmentState: () => void;
    updateApptDate: (inp: UpdateApptDateInp) => void;
    decodeVin: (vin: string, store: string, branch: string, checkOwned: string,
        lastName?: string, phoneNumber?: string, email?: string) => void;
    setIdkMileage: (value: string) => void;
    vwTrackingFlag?: string;
}

function parseMoney(numberString: string) {
    return toNumber(numberString.replace(/[^0-9.]+/g, ''));
}

const Summary = (props: IProps) => {
    const [contactMethod, setContactMethod] = useState<string>(() => {
        const pref = props.appointment.ApptCust.custPrefContact;
        if (pref === 'email') {
            return 'email';
        }
        if (pref === 'text' && props.smsLaunched === 'Y' && props.textOptIn === 'I') {
            return 'text';
        }

        return props.smsLaunched === 'Y' ? '' : 'email';
    });
    const [makePreferredContact, setMakePreferredContact] = useState<boolean>(() => {
        const pref = props.appointment.ApptCust.custPrefContact;

        return pref === 'email' || (pref === 'text' && props.smsLaunched === 'Y' && props.textOptIn === 'I');
    });
    const [preferContactSelect, setPreferContactSelect] = useState<string>('yes');
    const [disclaimerChecked, setDisclaimerChecked] = useState<boolean>(false);
    const [services, setServices] = useState<Services[]>();
    const [firstName, setFirstName] = useState<string>(props.appointment.ApptCust.custFirstName);
    const [lastName, setLastName] = useState<string>(props.appointment.ApptCust.custLastName);
    const [phoneNumber, setPhoneNumber] = useState<string>(props.appointment.ApptCust.custPhoneNumber);
    const [email, setEmail] = useState<string>(props.appointment.ApptCust.custEmailAddress);
    const initialEmail = useRef<string>(props.customerInfo?.emailAddress ?? '');
    const [error, setError] = useState(() => {
        const custFirst = props.appointment.ApptCust.custFirstName;
        const custLast = props.appointment.ApptCust.custLastName;
        const custPhone = props.appointment.ApptCust.custPhoneNumber;
        const custEmail = props.appointment.ApptCust.custEmailAddress;
        const nameLen = (custFirst + custLast).length;
        const strippedPhone = custPhone?.replace(/[^0-9*]/g, '') ?? '';
        const mileage = props.appointment.ApptVeh.mileage || 0;

        return {
            firstName: custFirst?.length <= 0 || nameLen > 35,
            lastName: custLast?.length <= 0 || nameLen > 35,
            phoneNumber: !(strippedPhone.includes('*') || strippedPhone.length === 10),
            emailAddress: custEmail?.includes('*') ? false : (!custEmail?.match(emailRegex) || custEmail?.length > 62),
            mileage: mileage !== -1 && mileage < props.prevMileage,
        };
    });
    const [customerOptIn, setCustomerOptIn] = useState<boolean>(false);
    const [dialogActive, setDialogActive] = useState(false);
    const [creatingAppointment, setCreatingAppointment] = useState<boolean>(false);
    const [cancellingAppointment, setCancellingAppointment] = useState<boolean>(false);
    const [checkOpcodes, setCheckOpcodes] = useState<boolean>(true);
    const [footerStart, setFooterStart] = useState<boolean>(false);
    const [sameEmail, setSameEmail] = useState<boolean>(false);
    const [showCancelMsg, setShowCancelMsg] = useState<boolean>(false);
    const [cancelPressed, setCancelPressed] = useState<boolean>(false);
    const [lockMsg, setLockMsg] = useState<string>('');
    const [apptMileage, setApptMileage] = useState(0);
    const [identVerifyUpdt, setIdentVerifyUpdt] = useState(false);
    const [displayMCMessage, setDisplayMCMessage] = useState(false);
    const [newDept, setNewDept] = useState<string>('');
    const [heldServices, setHeldServices] = useState<Services[]>();
    const [prevDept, setPrevDept] = useState<string>(props.appointment.Appointment.department);
    const [displayDeptChangeMessage, setDisplayDeptChangeMessage] = useState<boolean>(false);
    const [requireConsent, setRequireConsent] = useState<boolean>(false);
    const [requireConsentMessage, setRequireConsentMessage] = useState<string>('');
    const [disclaimerMessage, setDisclaimerMessage] = useState<string>(props.specData?.deptSpecs?.disclaimerMsg ?? '');
    const [custEmailUpdate, setCustEmailUpdate] = useState<boolean>(
        () => checkCustUpdateEmail(props.appointment?.Appointment.department,
            props.specData?.specs) || !props.customerInfo?.emailAddress);

    const [showTransRemoveWarning, setShowTransRemoveWarning] = useState(false);
    const [preferBothContactMethod, setPreferBothContactMethod] = useState('');
    const [firstChanged, setFirstChanged] = useState(false);
    const [lastChanged, setLastChanged] = useState(false);
    const [phoneChanged, setPhoneChanged] = useState(false);
    const [emailChanged, setEmailChanged] = useState(false);
    const [apptSubmitted, setApptSubmitted] = useState(false);
    const [initialIdkMileageChecked, setInitialIdkMileageChecked] = useState('');
    const [requiredInfoCompleted, setRequiredInfoCompleted] = useState(false);
    const [disclaimerMissing, setDisclaimerMissing] = useState(false);
    const [highlightSendConfirm, setHighlightSendConfirm] = useState(false);
    const [highlightNoServicesSelected, setHighlightNoServicesSelected] = useState(false);
    const firstNameRef = useRef<HTMLElement | null>(null);
    const lastNameRef = useRef<HTMLElement | null>(null);
    const phoneRef = useRef<HTMLElement | null>(null);
    const emailRef = useRef<HTMLElement | null>(null);
    const mileageRef = useRef<HTMLElement | null>(null);
    const [sendSD, setSendSD] = useState(false);
    const [sendGA4, setSendGA4] = useState(false);

    // always require identity verification for existing customers (identity always enforced)
    const forceVerifyIdentity = !props.identityVerified && !!props.customerInfo.firstName;

    const isSDAnalyticsEnabled =
        props.specData?.specs?.toyotaTrackingFlag === 'Y' ||
        props.specData?.specs?.lexusTrackingFlag === 'Y' ||
        props.specData?.specs?.mbzTrackingFlag === 'Y' ||
        props.specData?.specs?.mazdaCATrackingFlag === 'Y' ||
        props.specData?.specs?.vwTrackingFlag === 'Y' ||
        props.specData?.specs?.jaguarTrackingFlag === 'Y' ||
        props.specData?.specs?.landRoverTrackingFlag === 'Y';
    const vehicle: VehicleRec = {
        id: '',
        vin: props.appointment.ApptVeh.vin,
        makeCode: props.appointment.ApptVeh.makeCode,
        make: props.appointment.ApptVeh.make,
        model: props.appointment.ApptVeh.model,
        imagePath: props.appointment.ApptVeh.imagePath,
        year: props.appointment.ApptVeh.vehYr,
        color: props.appointment.ApptVeh.vehColor,
        style: props.appointment.ApptVeh.series,
        prevMileage: props.appointment.ApptVeh.mileage,
        prevRoDate: '',
        nextAppt: '',
        lastAdv: '',
        lastAdvName: '',
        lastAdvImage: '',
        lastTrans: '',
        lastTransLit: '',
        nameId: props.appointment.ApptCust.custNameId ?? '',
    };
    let mainDiv = css.mainDiv;
    let primaryMsg = strings.AddAppt;


    // Check if web ops and additional services have been loaded
    // This is only done if Viewing Appt list..
    let loadingOps = false;
    if (props.viewMode === ViewMode.EditAppt) {
        primaryMsg = strings.ConfirmUpdates;
        loadingOps = !props.additionalServices.allServices.built;
        if (props.individualServices) {
            if (props.individualServices.length === 1) {
                if (props.individualServices[0].id === '') {
                    loadingOps = true;
                }
            }
        }
    }

    useEffect(() => {
        const currentPane = props.mainPaneViewOrder[props.mainPaneViewOrder.length - 1];
        if (currentPane.viewId === ComponentMapIds.Summary) {
            if (props.appointment && isSDAnalyticsEnabled) {
                sendSdEvent('scheduleServiceReviewShown', buildApptData(props.sessionId,
                    getProviderId(props.specData?.specs, props.toyotaMCLaunched, props.toyotaTDMCLaunched,
                        props.lexusMCLaunched, props.lexusTDMCLaunched), props.appointment));
            }
        }
    // eslint-disable-next-line @reynolds/exhaustive-deps
    }, [props.mainPaneViewOrder]);

    // If we got here from the landing page, we need to determine the dept on
    // the appointment, and get the deptSpecs after ApptOps were updated.
    useEffect(() => {
        const defaultDept = {
            defaultDept: props.specData?.specs?.departmentFlag ?? '',
        };

        if (props.appointment.ApptOps.length > 0 && props.loadAppt) {
            props.determineDept(defaultDept);
        }
    }, [props.determineDept, props.appointment.ApptOps, props.specData?.specs?.departmentFlag, props.loadAppt]);

    useEffect(() => {
        if (props.appointment.Appointment.department && props.loadAppt) {
            props.getDeptSpecs();
        }
    }, [props.getDeptSpecs, props.appointment.Appointment.department, props.loadAppt]);

    // If we change appointments, clear the checks and recheck the services
    useEffect(() => {
        if (!props.appointment.Appointment.apptNum) {
            setCheckOpcodes(false);
        } else {
            props.clearCheckedWebOps();
            props.clearCheckedAdditionalServices();
            setCheckOpcodes(true);
        }
    }, [props.appointment.Appointment.apptNum, props.clearCheckedWebOps, props.clearCheckedAdditionalServices]);

    // If here on an edit, load the appointment ops and automatically check any services with opcodeds
    useEffect(() => {
        if (props.appointment.ViewApptList && !loadingOps &&
            props.individualServices.length && props.viewMode === ViewMode.EditAppt && checkOpcodes) {
            const apptList = props.appointment.ViewApptList.find(appt => appt.apptNum === props.appointment.Appointment.apptNum);
            const recommended = props.additionalServices.allServices.recom;
            const individualServices = props.individualServices;
            const allMenus = props.menus ? props.menus : [];
            if (apptList) {
                const apptOps: UpdateApptOpsInp[] = [];
                let recomCount = 0;
                let indivCount = 0;
                setApptMileage(apptList.mileage);
                apptList.ApptOps.forEach((service, index) => {
                    // Search recommended services opcodes
                    const recomIndex = recommended.findIndex((recom) => recom.opCode === service.opCode);
                    // Search Individual service opcodes
                    const individualIndex = individualServices.findIndex((indiv) => indiv.id === service.opCode);
                    const menuIndex = allMenus.findIndex((menu) => (menu.title === service.opDesc) && (service.opCode !== 'SMENU'));
                    if (recomIndex !== -1) {
                        apptOps.push({
                            id: 'recom' + recomCount,
                            operation: recommended[recomIndex].opCode,
                            concern: recommended[recomIndex].opDesc,
                            estTime: '',
                            menuID: '',
                            spgOp: '',
                            opType: OpType.RecommendedService,
                            itemCostLow: recommended[recomIndex].opPrice,
                            itemCostHigh: recommended[recomIndex].opPrice,
                            department: recommended[recomIndex].department,
                            opWaiter: recommended[recomIndex].opWaiter,
                            opLoaner: recommended[recomIndex].opLoaner,
                            opRental: recommended[recomIndex].opRental,
                            opConcierge: recommended[recomIndex].opConcierge,
                            opCadillac: recommended[recomIndex].opCadillac,
                            opPPUDWL: recommended[recomIndex].opPPUDWL,
                        });
                        props.toggleRecommended(recommended[recomIndex].opCode);
                        recomCount++;
                    } else if (individualIndex !== -1) {
                        apptOps.push({
                            id: 'individualService' + indivCount,
                            operation: props.individualServices[individualIndex].id,
                            concern: props.individualServices[individualIndex].webTitle,
                            estTime: props.individualServices[individualIndex].estTime,
                            menuID: '',
                            spgOp: props.individualServices[individualIndex].spgOp,
                            opType: OpType.IndividualService,
                            itemCostLow: props.individualServices[individualIndex].itemCostLow,
                            itemCostHigh: props.individualServices[individualIndex].itemCostHigh,
                            department: props.individualServices[individualIndex].department,
                            opWaiter: props.individualServices[individualIndex].opWaiter,
                            opLoaner: props.individualServices[individualIndex].opLoaner,
                            opRental: props.individualServices[individualIndex].opRental,
                            opConcierge: props.individualServices[individualIndex].opConcierge,
                            opCadillac: props.individualServices[individualIndex].opCadillac,
                            opPPUDWL: props.individualServices[individualIndex].opPPUDWL,
                        });
                        props.toggleItem(props.individualServices[individualIndex].id);
                        indivCount++;
                    } else if (menuIndex !== -1) {
                        apptOps.push({
                            id: 'maintMenu' + props.menus[menuIndex].id,
                            operation: service.opCode,
                            concern: props.menus[menuIndex].title,
                            estTime: '',
                            menuID: props.menus[menuIndex].id,
                            spgOp: '',
                            opType: service.opCode === 'MMENU' ? OpType.MaintenanceMenu : OpType.ConditionalMaintMenu,
                            itemCostLow: props.menus[menuIndex].itemCostLow,
                            itemCostHigh: props.menus[menuIndex].itemCostHigh,
                            department: props.menus[menuIndex].dept,
                            opWaiter: '',
                            opLoaner: '',
                            opRental: '',
                            opConcierge: '',
                            opCadillac: '',
                            opPPUDWL: '',
                        });
                        props.toggleMenu(props.menus[menuIndex].id);
                    } else {
                        apptOps.push({
                            id: (index).toString(),
                            operation: service.opCode,
                            concern: service.opDesc,
                            estTime: '',
                            menuID: '',
                            spgOp: '',
                            opType: OpType.ViewApptListService,
                            department: '',
                            itemCostLow: service.opQuote ? service.opQuote : '',
                            itemCostHigh: service.opQuote ? service.opQuote : '',
                            opWaiter: '',
                            opLoaner: '',
                            opRental: '',
                            opConcierge: '',
                            opCadillac: '',
                            opPPUDWL: '',
                        });
                    }
                });
                props.UpdateApptOps(apptOps);
                if (apptList.scheduleOption) {
                    props.setScheduleOption(apptList.scheduleOption);
                }
                if (apptList.mileageMenu) {
                    props.setMileageOption(apptList.mileageMenu);
                }
            }
            setCheckOpcodes(false);
        }
    }, [props.viewMode, props.additionalServices.allServices, props.appointment, props.individualServices, checkOpcodes,
        loadingOps, props.toggleRecommended, props.toggleItem, props.UpdateApptOps, props.menus, props.toggleMenu,
        props.setScheduleOption, props.setMileageOption, props.specData, props.deptChangeFlag]);

    useEffect(() => {
        const {custEmailAddress, custFirstName, custLastName, custPhoneNumber} = props.appointment.ApptCust;
        setFirstName(custFirstName);
        setLastName(custLastName);
        setPhoneNumber(custPhoneNumber);
        setEmail(custEmailAddress);
        if (props.appointment && isSDAnalyticsEnabled) {
            sendSdEvent('scheduleServiceFormShown', buildApptData(props.sessionId,
                getProviderId(props.specData?.specs, props.toyotaMCLaunched, props.toyotaTDMCLaunched,
                    props.lexusMCLaunched, props.lexusTDMCLaunched), props.appointment));
        }
    }, [props.appointment.ApptCust, props.appointment, props.sessionId, props.specData,
        props.toyotaMCLaunched, props.toyotaTDMCLaunched, props.lexusMCLaunched,
        props.lexusTDMCLaunched, isSDAnalyticsEnabled]);

    let totalMinCost: string = '';
    let holdMinCost: number = 0;

    // If services have not been built or have been updated elsewhere, build them.
    useEffect(() => {
        const servicesArray: Services[] = [];
        props.appointment.ApptOps.forEach((apptOp) => {
            // Do not count Skip Service unless in edit mode
            if (apptOp.opType === OpType.SkipServiceReason && props.viewMode !== ViewMode.EditAppt) {
                return;
            }
            let range = strings.CallDealerForPricing;
            let itemCostLowString = '';
            if ((apptOp.itemCostLow !== '****') && (apptOp.itemCostLow !== '')) {
                itemCostLowString = '$' + (Number(apptOp.itemCostLow) / 100).toFixed(2);
            }
            let itemCostHighString = '';
            if ((apptOp.itemCostHigh !== '****') && (apptOp.itemCostHigh !== '')) {
                itemCostHighString = '$' + (Number(apptOp.itemCostHigh) / 100).toFixed(2);
            }
            if (apptOp.itemCostHigh === '') {
                if (props.theme === 'lexus' || props.theme === 'lexusMonogram') {
                    range = itemCostLowString;
                } else {
                    range = strings.StartingAt + ' ' + itemCostLowString;
                }
            }
            if (apptOp.itemCostLow === '') {
                range = strings.UpTo + ' ' + itemCostHighString;
            }
            if ((apptOp.itemCostLow !== '') &&
                (apptOp.itemCostLow !== '****') &&
                (apptOp.itemCostHigh !== '') &&
                (apptOp.itemCostHigh !== '****')) {
                range = itemCostLowString + ' - ' + itemCostHighString;
            }
            if ((apptOp.itemCostHigh === apptOp.itemCostLow) &&
                (apptOp.itemCostLow !== '****') &&
                (apptOp.itemCostHigh !== '****')) {
                range = itemCostHighString;
            }

            // send email about this
            let webOpLangTitle = props.individualServices.find(indSvc => indSvc.id === apptOp.operation)?.webTitleEN;
            if (props.locale === 'fr-CA') {
                webOpLangTitle = props.individualServices.find(indSvc => indSvc.id === apptOp.operation)?.webTitleFR;
            }
            let serviceName = webOpLangTitle ? webOpLangTitle : apptOp.concern;
            if (props.hidePriceLabel && ((apptOp.itemCostLow === '' && apptOp.itemCostHigh === '') ||
                (apptOp.itemCostLow === '****' || apptOp.itemCostHigh === '****'))) {
                serviceName = `${serviceName}*`;
                range = '';
            }

            if (props.hidePriceLabel && apptOp.itemCostLow === '') {
                serviceName = `${serviceName}*`;
            }
            servicesArray.push({
                serviceName: serviceName,
                id: apptOp.id,
                priceHigh: itemCostHighString,
                priceLow: itemCostLowString,
                range: range,
                type: apptOp.opType,
            });
        });
        setServices(servicesArray);
    }, [props.appointment.ApptOps, props.additionalServices, props.viewMode, props.individualServices, props.locale,
        props.hidePriceLabel, props.theme,
    ]);

    useEffect(() => {
        if (props.maintContracts) {
            props.maintContracts.forEach(contract => {
                if (contract.status === 'Active') {
                    setDisplayMCMessage(true);
                }
            });
        }
    }, [props.maintContracts]);

    useEffect(() => {
        if (props.viewMode === ViewMode.EditAppt && props.myGMRewardsLaunched === 'Y' && !props.gmMemberErr) {
            props.gmMemberSearch(props.appointment.ApptCust.custEmailAddress);
        }
    }, [props.appointment.ApptCust.custEmailAddress,
        props.gmMemberSearch,
        props.viewMode,
        props.myGMRewardsLaunched,
        props.gmMemberErr]);

    useEffect(() => {
        const currentPane = props.mainPaneViewOrder[props.mainPaneViewOrder.length - 1];
        if (currentPane.viewId === ComponentMapIds.Summary) {
            const ascPageViewInp: ascPageviewInput = {
                pageType: 'service',
                errorCode: '',
                itemResults: '',
            };
            ascPageview(ascPageViewInp, props.vehicles, props.selectedVehicle);

            const ascFormEngagementInp: ascFormEngagementInput = {
                pageType: 'service',
                commType: 'form',
                commStatus: 'engage',
                elementText: '',
                department: 'service',
                formName: 'Service_Portal_2',
                formType: 'service_appointment',
            };
            ascFormEngagement(ascFormEngagementInp, props.vehicles, props.selectedVehicle);
        }
    }, [props.mainPaneViewOrder, props.vehicles, props.selectedVehicle]);

    if (services) {
        services.forEach((service) => {
            let itemCostLowNum: number = 0;
            if (service.priceLow && (service.priceLow !== '****') && (totalMinCost !== '****')) {
                itemCostLowNum = parseMoney(service.priceLow);
                holdMinCost += itemCostLowNum;
                totalMinCost = holdMinCost.toString();
            } else {
                totalMinCost = '****';
            }
        });
    }

    let skipServiceReason: string | undefined = undefined;
    if (services?.length === 0) {
        skipServiceReason = props.appointment.ApptOps.find(op => op.opType === OpType.SkipServiceReason)?.concern;
    }

    const advArr = props.advisors?.find((advisors) => advisors.advisorNum === props.appointment.Appointment.advisor);
    const advName = advArr?.advisorName;
    const AdvImgAltTag = advName + ' ' + strings.Photo;

    // Create a duplicate to avoid overwriting error state changes when multiple fields are changed at once
    let errorCopy = { ...error };

    const validateFirstName = (value: string) => {
        if (value?.length <= 0 || (value + lastName).length > 35) {
            if (!errorCopy.firstName) {
                errorCopy = { ...errorCopy, firstName: true };
            }
            if ((value + lastName).length > 35 && !errorCopy.lastName) {
                errorCopy = { ...errorCopy, lastName: true };
            }
        } else {
            if (errorCopy.firstName) {
                errorCopy = { ...errorCopy, firstName: false };
            }
            if (lastName && errorCopy.lastName) {
                errorCopy = { ...errorCopy, lastName: false };
            }
        }
    };

    const validateLastName = (value: string) => {
        if (value?.length <= 0 || (value + firstName).length > 35) {
            if (!errorCopy.lastName) {
                errorCopy = { ...errorCopy, lastName: true };
            }
            if ((value + firstName).length > 35 && !errorCopy.firstName) {
                errorCopy = { ...errorCopy, firstName: true };
            }
        } else {
            if (errorCopy.lastName) {
                errorCopy = { ...errorCopy, lastName: false };
            }
            if (firstName && errorCopy.firstName) {
                errorCopy = { ...errorCopy, firstName: false };
            }
        }
    };

    const validatePhoneNumber = (value: string) => {
        const strippedPhone = value?.replace(/[^0-9*]/g, '') ?? '';
        if (strippedPhone.includes('*') || strippedPhone.length === 10) {
            if (errorCopy.phoneNumber) {
                errorCopy = { ...errorCopy, phoneNumber: false };
            }
        } else {
            if (!errorCopy.phoneNumber) {
                errorCopy = { ...errorCopy, phoneNumber: true };
            }
        }
    };

    const validateEmail = useCallback((value: string) => {
        setError(prevError => {
            if (value?.includes('*')) {
                return { ...prevError, emailAddress: false };
            }
            const isEmailInvalid = !value?.match(emailRegex) || value?.length > 62;

            return { ...prevError, emailAddress: isEmailInvalid };
        });
    }, []);

    const validateMileage = (mileageNum: number) => {
        if (mileageNum !== -1 && mileageNum < props.prevMileage) {
            errorCopy = { ...errorCopy, mileage: true };
        } else {
            errorCopy = { ...errorCopy, mileage: false };
        }
    };


    const removeApptOps = useCallback((servicesCopy: Services[]) => {
        let writeYourOwnCount = 0;
        servicesCopy?.forEach((service) => {
            if (service.id.substr(0, 9) === 'diagnosis') {
                service.id = 'diagnosis' + writeYourOwnCount;
                writeYourOwnCount++;
            }
        });
        const opsArrayCopy: UpdateApptOpsInp[] = [...props.appointment.ApptOps];
        const opsArray: UpdateApptOpsInp[] = [];
        writeYourOwnCount = 0;
        opsArrayCopy.forEach((op) => {
            if (servicesCopy.find(svc => op.id === svc.id)) {
                // Need to readjust writeYourOwn ids in case one has been deleted
                if (op.opType === OpType.WriteYourOwn) {
                    const opCopy = { ...op, id: 'diagnosis' + writeYourOwnCount };
                    opsArray.push(opCopy);
                    writeYourOwnCount++;
                } else {
                    opsArray.push(op);
                }
            } else {
                if (op.opType === OpType.MaintenanceMenu ||
                    op.opType === OpType.ConditionalMaintMenu) {
                    props.toggleMenu(op.menuID);
                }
                if (op.opType === OpType.WeOwe) {
                    props.toggleWeOwe(op.concern);
                }
                if (op.opType === OpType.RecommendedService) {
                    props.toggleRecommended(op.operation);
                    props.toggleItem(op.operation);
                }
                if (op.opType === OpType.IndividualService) {
                    props.toggleItem(op.operation);
                    props.toggleRecommended(op.operation);
                }
                // SkipServiceReason does not exist in services but should not be deleted
                if (op.opType === OpType.SkipServiceReason) {
                    opsArray.push(op);
                }
            }
        });
        props.UpdateApptOps(opsArray);
    }, [
        props.UpdateApptOps,
        props.toggleItem,
        props.toggleMenu,
        props.toggleRecommended,
        props.toggleWeOwe,
        props.appointment.ApptOps,
    ]);

    const footerHandler = (e: any) => {
        // Required fields that are incomplete or need attention will be focus on screen with a warning message.
        if (!requiredInfoCompleted) {
            const focusErrorField =
                (error.firstName && firstNameRef.current?.querySelector('input')) ||
                (error.lastName && lastNameRef.current?.querySelector('input')) ||
                (error.phoneNumber && phoneRef.current?.querySelector('input')) ||
                (error.emailAddress && emailRef.current?.querySelector('input')) ||
                (error.mileage && mileageRef.current?.querySelector('input'));

            if (focusErrorField) {
                focusErrorField.focus();

                return;
            }

            if (services?.length === 0 && !props.skipServices && !skipServiceReason) {
                setHighlightNoServicesSelected(true);
                setTimeout(() => {
                    const noServicesElement = document.getElementById('servicesHeader');
                    if (noServicesElement) {
                        noServicesElement.scrollIntoView(true);
                    }
                }, 100);

                return;
            }

            if (!contactMethod) {
                setHighlightSendConfirm(true);
                setTimeout(() => {
                    const contactMethodElement = document.getElementById('contactMethodButtons');
                    if (contactMethodElement) {
                        contactMethodElement.scrollIntoView(true);
                    }
                }, 100);

                return;
            }
            if (!disclaimerChecked) {
                setDisclaimerMissing(true);
                setTimeout(() => {
                    const checkboxElement = document.getElementById('disclaimerCheckbox');
                    if (checkboxElement) {
                        checkboxElement.scrollIntoView(true);
                    }
                }, 100);

                return;
            }

            return;
        }
        if (email === initialEmail.current) {
            setFooterStart(true);
            setSameEmail(true);
        }
        if (email !== initialEmail.current) {
            setFooterStart(true);
            setSameEmail(false);
            // Go to review appointment screen and store new customer information
            // If makePreferredContact is equal to 'yes' then the preferred contact will be set to the selected contactMethod.
            // Otherwise if it not equal to 'no', then it must be equal to either 'text' or 'email' so set it to that.
            props.checkUniqueEmail(
                email,
                props.appointment.ApptCust.custNameId ? props.appointment.ApptCust.custNameId:'',
                props.profile,
                props.store,
                props.branch,
                props.appointment.ApptCust.custFirstName,
                props.appointment.ApptCust.custLastName,
                props.appointment.ApptCust.custPhoneNumber,
            );
            // We decode the VIN again here if the email is different to prevent VINOWNED being sent on an appointment by the owner
            props.decodeVin(props.appointment.ApptVeh.vin, props.store, props.branch, 'Y', props.appointment.ApptCust.custLastName,
                props.appointment.ApptCust.custPhoneNumber, props.appointment.ApptCust.custEmailAddress,
            );
        }
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'service',
            elementText: primaryMsg,
            elementColor: '',
            elementOrder: '',
            elementType: 'footer',
            elementSubType: 'nav_button',
            eventAction: 'click',
            eventActionResult: 'next_step',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
        const ascFormEngagementInp: ascFormEngagementInput = {
            pageType: 'service',
            commType: 'form',
            commStatus: 'engage',
            elementText: primaryMsg,
            department: 'service',
            formName: 'Service_Portal_2',
            formType: 'service_appointment',
        };
        ascFormEngagement(ascFormEngagementInp, props.vehicles, props.selectedVehicle);

        if (props.appointment && isSDAnalyticsEnabled) {
            sendSdEvent('scheduleServiceReviewFinish', buildApptData(props.sessionId,
                getProviderId(props.specData?.specs, props.toyotaMCLaunched, props.toyotaTDMCLaunched,
                    props.lexusMCLaunched, props.lexusTDMCLaunched), props.appointment));
        }

        if (window.utag) {
            if (props.customerInfo?.encryptEmail ||
                props.customerInfo?.encryptFirst ||
                props.customerInfo?.encryptPhone ||
                props.customerInfo?.encryptLast) {
                if (firstChanged || lastChanged || emailChanged || phoneChanged) {
                    const changeCustInfoInp : Customer = {
                        ...props.customerInfo,
                        nameId: props.customerInfo.nameId ? props.customerInfo.nameId : props.selectedVehicle,
                        firstName: firstChanged ? props.appointment?.ApptCust?.custFirstName : props.customerInfo?.firstName,
                        lastName: lastChanged ? props.appointment?.ApptCust?.custLastName : props.customerInfo?.lastName,
                        emailAddress: emailChanged ? props.appointment?.ApptCust?.custEmailAddress :
                            props.customerInfo?.emailAddress,
                        phoneNumber: phoneChanged ? props.appointment?.ApptCust?.custPhoneNumber : props.customerInfo?.phoneNumber,
                    };
                    props.changeCustInfo(changeCustInfoInp, props.profile, props.store, props.branch, props.previewFlag);
                    setApptSubmitted(true);
                } else {
                    const identityLinkInp : Customer =
                        {
                            ...props.customerInfo,
                            encryptFirst: props.customerInfo?.encryptFirst,
                            encryptLast: props.customerInfo?.encryptLast,
                            encryptEmail: props.customerInfo?.encryptEmail,
                            encryptPhone: props.customerInfo?.encryptPhone,
                        };
                    utagIdentityLink(identityLinkInp);
                }
            } else if (props.appointment?.ApptCust?.custEmailAddress ||
                    props.appointment?.ApptCust?.custFirstName ||
                    props.appointment?.ApptCust?.custPhoneNumber ||
                    props.appointment?.ApptCust?.custLastName) {
                const identityLinkInp: Customer = {
                    nameId: '',
                    firstName: props.appointment?.ApptCust?.custFirstName,
                    lastName: props.appointment?.ApptCust?.custLastName,
                    emailAddress: props.appointment?.ApptCust?.custEmailAddress,
                    phoneNumber: props.appointment?.ApptCust?.custPhoneNumber,
                    login: false,
                    prefContact: '',
                    textOptIn: '',
                    emailOptIn: '',
                    streetAddress: '',
                    city: '',
                    stateAddress: '',
                    zipCode: '',
                    addVehNameId: '',
                    gmRedeemAmt: '',
                    encryptFirst: '',
                    encryptLast: '',
                    encryptEmail: '',
                    encryptPhone: '',
                    ascCustId: '',
                };
                utagIdentityLink(identityLinkInp);
            }
        }
    };

    let secondaryMessage = '';

    if (props.specData?.specs?.cancelFlag === 'Y' && props.viewMode === ViewMode.EditAppt) {
        secondaryMessage = strings.CancelAppt;
        mainDiv = css.editMainDiv;
    }

    const handlePreferBothContactMethodChange = useCallback((method) => {
        setPreferBothContactMethod(method);
        if (preferContactSelect === '') {
            setPreferContactSelect('yes');
        }
    }, [preferContactSelect]);

    useEffect(() => {
        if (props.changeCustReturned && apptSubmitted) {
            utagIdentityLink(props.customerInfo);
            props.setChangeCustReturned(false);
            setApptSubmitted(false);
        }
    }, [props.changeCustReturned, apptSubmitted, props.customerInfo, props.setChangeCustReturned]);

    useEffect(() => {
        if (footerStart && (props.custError==='0000' || sameEmail)) {
            setFooterStart(false);
            setSameEmail(false);
            props.clearCustError();
            setCreatingAppointment(true);
            let preferredContact = '';
            let apptCustPrefContact = '';
            if (preferContactSelect === 'yes') {
                preferredContact = contactMethod;
                apptCustPrefContact = email;
                if (contactMethod === 'text') {
                    apptCustPrefContact = phoneNumber?.replace(/[^0-9]/g, '');
                }
            } else if (preferContactSelect !== 'no' && preferContactSelect !== '') {
                preferredContact = preferContactSelect;
                apptCustPrefContact = email;
                if (preferContactSelect === 'text') {
                    apptCustPrefContact = phoneNumber?.replace(/[^0-9]/g, '');
                }
            }

            if (contactMethod === 'both'){
                if (preferBothContactMethod === 'email'){
                    apptCustPrefContact = email;
                }
                if (preferBothContactMethod === 'text') {
                    apptCustPrefContact = phoneNumber?.replace(/[^0-9]/g, '');
                }
            }
            const inp: UpdateApptCustInp = {
                nameId: props.appointment.ApptCust.custNameId ?? '',
                firstName: firstName,
                lastName: lastName,
                emailAddress: email,
                phoneNumber: phoneNumber,
                phoneType: props.appointment.ApptCust.custPhoneType,
                prefContact: apptCustPrefContact,
                loggedIn: props.appointment.ApptCust.custLoggedIn,
            };
            // If account information on the appointment is attached to an employee, changes
            // should be saved as Employee Info, which is passed as comments
            // on the Appointment to prevent updating the employee NAMES record from Portal.
            if (props.employeeFlag) {
                const empInp: EmployeeChanges = {};
                if (firstName !== props.customerInfo.firstName && !firstName.includes('**')) {
                    inp.firstName = props.customerInfo.firstName;
                    empInp.empFirst = firstName;
                }
                if (lastName !== props.customerInfo.lastName && !lastName.includes('**')) {
                    inp.lastName = props.customerInfo.lastName;
                    empInp.empLast = lastName;
                }
                if (email !== props.customerInfo.emailAddress && !email.includes('**')) {
                    inp.emailAddress = props.customerInfo.emailAddress;
                    empInp.empEmail = email;
                }
                if (phoneNumber !== props.customerInfo.phoneNumber && !phoneNumber.includes('**')){
                    inp.phoneNumber = props.customerInfo.phoneNumber;
                    empInp.empPhone = phoneNumber;
                }
                props.updateEmployeeChanges(empInp);
            }
            props.updateApptCust(inp);
            if (props.decodeErr?.split(':')[0] === 'VINOWNED') {
                const updateApptInp = {
                    ...props.appointment.ApptVeh,
                    vin: '',
                };
                props.updateApptVeh(updateApptInp);
            }
            if (props.loadAppt && services && !props.appointment.ApptCust.custNameId) {
                props.editAppt(services, customerOptIn, preferredContact, contactMethod);
                removeApptOps([...services]);
                props.ClearTokenData();

                return;
            }
            if (props.viewMode === ViewMode.Appt) {
                setLockMsg(strings.MessageAdding);
                const vehSel = props.vehicles.find(v => v.id === props.selectedVehicle);
                const isOEM = vehSel?.isOEM === 'Y' ? 'Y' : '' as string;
                props.createAppt(services ?? [], customerOptIn, preferredContact, contactMethod, isOEM);
                // Send the appointment to GM
                if (props.gmTrackingFlag) {
                    try {
                        cpp.trackEvent({ 'event_name': 'cpp_oss_rr_load' });
                    } catch (error) {
                        // nothing to return
                    }
                }
            } else if (props.viewMode === ViewMode.EditAppt && services) {
                // If we came here with a CustAcct viewmode then we are editing the appointment
                setLockMsg(strings.MessageUpdating);
                props.editAppt(services, customerOptIn, preferredContact, contactMethod);
                removeApptOps([...services]);
                props.clearROState();
            }
        }
    }, [props.createAppt, props.updateApptCust, props.editAppt, removeApptOps, props.appointment, makePreferredContact,
        customerOptIn, contactMethod, firstName, lastName, email, phoneNumber, services, sameEmail, props.viewMode,
        props.gmTrackingFlag, props.loadAppt, props.ClearTokenData, props.clearROState, footerStart, props.custError,
        props.clearCustError, props.selectedVehicle, props.customerInfo,
        props.specProfile, props.store, props.branch, props.previewFlag, props.decodeErr, props.updateApptVeh,
        props.employeeFlag, props.updateEmployeeChanges, props.vehicles, preferBothContactMethod, preferContactSelect]);

    useEffect(() => {
        if (!initialIdkMileageChecked) {
            setInitialIdkMileageChecked(props.idkMileage);
        }
    }, [props.idkMileage, initialIdkMileageChecked]);

    const changePrevMileage = (_: string, mileage: number) => {
        // Parse the mileage string, then create a copy of the vehicle to then update with the new mileage
        let mileageNum = mileage;
        if (isNaN(mileageNum)) {
            mileageNum = 0;
        }
        if (mileageNum !== props.appointment.ApptVeh.mileage) {
            props.updateVehicleMileage(mileageNum);
            props.getMenus('', '');
        }
        if (mileageNum > props.prevMileage) {
            props.setIdkMileage('N');
        } else {
            if (initialIdkMileageChecked === 'Y') {
                props.setIdkMileage('Y');
            }
        }
        validateMileage(mileageNum);
        setError(errorCopy);
    };

    const continueRemoveService = useCallback((id: string) => {
        const servicesCopy = services?.filter(service => service.id !== id);
        const defaultDept = {
            defaultDept: props.specData?.specs?.departmentFlag ?? '',
        };
        if (servicesCopy) {
            removeApptOps(servicesCopy);
        }
        props.determineDept(defaultDept);
        setServices(servicesCopy);
        props.getApptOps(props.specProfile, props.store, props.branch);
    }, [props.branch, props.determineDept, props.getApptOps,
        props.specData?.specs?.departmentFlag, props.specProfile, props.store, removeApptOps, services]);

    const removeService = (id: string) => {
        // if the trans type is rental or loaner then display warning message to explain that the service cannot be removed.
        const rentalMinEstTimeCheck = (props.specData?.specs?.svcSpecs &&
            (props.specData?.specs?.svcSpecs?.rentalMinEst > 0 || props.specData?.specs?.svcSpecs.rentalConcernOnly > 0)) ||
            (props.specData?.specs?.bdySpecs && props.specData?.specs?.bdySpecs?.rentalMinEst > 0) ||
            (props.specData?.specs?.ossSpecs &&
            (props.specData?.specs?.ossSpecs?.rentalMinEst > 0 || props.specData?.specs?.ossSpecs?.rentalConcernOnly > 0));
        const loanerMinEstTimeCheck = (props.specData?.specs?.svcSpecs &&
            (props.specData?.specs?.svcSpecs?.loanerMinEst > 0 || props.specData?.specs?.svcSpecs.loanerConcernOnly > 0)) ||
            (props.specData?.specs?.bdySpecs && props.specData?.specs?.bdySpecs?.loanerMinEst > 0) ||
            (props.specData?.specs?.ossSpecs &&
            (props.specData?.specs?.ossSpecs?.loanerMinEst > 0 || props.specData?.specs?.ossSpecs?.loanerConcernOnly > 0));

        const selectedOp = props.appointment.ApptOps.find(op => op.id === id);

        if (props.appointment && isSDAnalyticsEnabled) {
            sendSdEvent('scheduleServiceReviewStart', buildApptData(props.sessionId,
                getProviderId(props.specData?.specs, props.toyotaMCLaunched, props.toyotaTDMCLaunched,
                    props.lexusMCLaunched, props.lexusTDMCLaunched), props.appointment));
        }
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'service',
            elementText: selectedOp?.concern ?? '',
            elementColor: '',
            elementOrder: '',
            elementType: 'scheduling_tool',
            elementSubType: 'other_buttons',
            eventAction: 'click',
            eventActionResult: 'close',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, id, props.vehicles, props.selectedVehicle);
        const ascElementConfigurationInp: ascElementConfigurationInput = {
            pageType: 'service',
            elementText: selectedOp?.concern ?? '',
            elementType: 'scheduling_tool',
            elementColor: '',
            eventAction: 'click',
            eventActionResult: 'close',
            linkUrl: '',
        };
        ascElementConfiguration(ascElementConfigurationInp, id);

        if ((props.appointment.Appointment.transFlag === 'R' &&
            rentalMinEstTimeCheck) ||
            (props.appointment.Appointment.transFlag === 'L' &&
            loanerMinEstTimeCheck)) {
            setShowTransRemoveWarning(true);

            return;
        }
        // First check if removing the service will cause a change in department.
        const newOps = props.appointment.ApptOps.filter(op => op.id !== id);
        // Save the services array with the service removed for updating later if department change warning is necessary.
        setHeldServices(services?.filter(service => service.id !== id));
        // No need to check Department change if length of services is zero.
        if (newOps.length) {
            // Determine the department with the selected service removed.
            let workingDept = '';
            let varDepartment = props.specData?.specs?.departmentFlag ?? '';
            for (const x in newOps) {
                const opDepartment = newOps[x].department;
                switch (workingDept) {
                    case '':
                        workingDept = opDepartment;
                        break;
                    case opDepartment:
                        break;
                    default: {
                        if (props.specData?.specs?.svcSpecs) {
                            workingDept = 'S';
                        } else if (props.specData?.specs?.ossSpecs) {
                            workingDept = 'Q';
                        } else if (props.specData?.specs?.bdySpecs) {
                            workingDept = 'B';
                        }
                    }
                }
            }
            if (workingDept !== '') {
                varDepartment = workingDept;
            }
            setNewDept(varDepartment);
            if (varDepartment !== prevDept) {
                // Display the Department Change warning.
                setDisplayDeptChangeMessage(true);
            } else {
                continueRemoveService(id);
            }
        } else {
            continueRemoveService(id);
        }
    };

    const toggleDisclaimerCheck = (e: any) => {
        setDisclaimerChecked((prevChecked) => {
            const newChecked = !prevChecked;
            setDisclaimerMissing(!newChecked);
            const ascCtaInteractionInp : ascCtaInteractionInput = {
                pageType: 'service',
                elementText: props.specData?.deptSpecs?.requireConsMsg ?? '',
                elementColor: '',
                elementOrder: '',
                elementType: 'scheduling_tool',
                elementSubType: 'checkbox',
                eventAction: 'click',
                eventActionResult: disclaimerChecked ? 'uncheck' : 'check',
                linkUrl: '',
            };
            ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);

            const ascFormEngagementInp: ascFormEngagementInput = {
                pageType: 'service',
                commType: 'form',
                commStatus: 'engage',
                elementText: props.specData?.deptSpecs?.requireConsMsg ?? '',
                department: 'service',
                formName: 'Service_Portal_2',
                formType: 'service_appointment',
            };
            ascFormEngagement(ascFormEngagementInp, props.vehicles, props.selectedVehicle);

            return newChecked;
        });

        if (props.appointment && isSDAnalyticsEnabled) {
            sendSdEvent('scheduleServiceReviewStart', buildApptData(props.sessionId,
                getProviderId(props.specData?.specs, props.toyotaMCLaunched, props.toyotaTDMCLaunched,
                    props.lexusMCLaunched, props.lexusTDMCLaunched), props.appointment));
        }
    };

    const toggleMakePreferredContact = useCallback(() => {
        if (makePreferredContact) {
            setPreferContactSelect('');
        } else {
            setPreferContactSelect('yes');
        }
        setMakePreferredContact(!makePreferredContact);
    }, [makePreferredContact]);

    const updateApptCustHandler = (field: string, value: string) => {
        const apptCustInp: UpdateApptCustInp = {
            nameId: props.appointment.ApptCust.custNameId,
            firstName: firstName,
            lastName: lastName,
            emailAddress: email,
            phoneNumber: phoneNumber,
            prefContact: props.appointment.ApptCust.custPrefContact,
            loggedIn: props.customerInfo?.login,
        };

        apptCustInp[field] = value;

        props.onApptCustUpdate(apptCustInp);
    };

    const nameChangeHandler = (id: string, value: string) => {
        switch (id) {
            case 'firstName':
                setFirstName(value);
                validateFirstName(value);
                setError(errorCopy);
                break;
            case 'lastName':
                setLastName(value);
                validateLastName(value);
                setError(errorCopy);
                break;
            default:
                break;
        }
    };

    const phoneNumberChangedHandler = (_: string, value: string) => {
        const formattedValue = value.replace(/[^0-9]/g, '');
        validatePhoneNumber(value);
        setPhoneNumber(formattedValue);
        setError(errorCopy);
    };

    const emailChangedHandler = (_: string, value: string) => {
        // validateEmail updates error.emailAddress via a functional setError that preserves the
        // other error fields, so a trailing setError(errorCopy) here would clobber its result
        // with a stale snapshot and leave the email field permanently flagged as invalid.
        validateEmail(value);
        setEmail(value);
    };

    const changeContactMethodHandler = useCallback((value: string) => {
        if (value !== contactMethod) {
            if (value === 'both' || contactMethod === 'both') {
                setMakePreferredContact(false);
                setPreferContactSelect('');
            }
            if ((value === 'both' || value === 'text') && !customerOptIn && props.textOptIn !== 'I') {
                setDialogActive(true);
                const ascPageViewInp: ascPageviewInput = {
                    pageType: 'service',
                    errorCode: '',
                    itemResults: '',
                };
                ascPageview(ascPageViewInp, props.vehicles, props.selectedVehicle);
            }
            setContactMethod(value);
            setHighlightSendConfirm(false);
        }
    }, [contactMethod, customerOptIn, props.textOptIn, props.vehicles, props.selectedVehicle]);

    const closeDialog = useCallback(() => {
        setDialogActive(false);
    }, []);

    const buttonsHandler = useCallback((id: string) => {
        if (id === 'yes' && !customerOptIn) {
            setCustomerOptIn(true);
            setDialogActive(false);
        }
        if (id === 'okay') {
            props.clearTextCheckReturned();
            // If we have no customer ID, (i.e. a new customer) pass the phone number instead
            let phone: string | undefined = phoneNumber?.replace(/[^0-9]/g, '');
            let custId = '';
            if (props.appointment.ApptCust.custNameId) {
                phone = undefined;
                custId = props.appointment.ApptCust.custNameId;
            }
            props.checkPhoneOptIn(custId, props.profile, props.store, props.branch, phone);
        }
        if (id === 'no') {
            props.clearTextCheckReturned();
            setContactMethod('');
            setDialogActive(false);
        }
    }, [customerOptIn, props.appointment.ApptCust.custNameId, props.profile, props.store,
        props.branch, props.checkPhoneOptIn, phoneNumber, props.clearTextCheckReturned]);

    // Disable the footer if the disclaimer is not checked and specs requires the consent flag,
    // or if any of the customer information is not filled in,
    // or if the customer is not opted in and has set the contact method to text or both
    // Do not disable if skipServices or skipServiceReason is true and there are no services
    const requiredInfoError = (!disclaimerChecked && props.specData?.deptSpecs?.requireConsFlg === 'Y') ||
        error.emailAddress || error.firstName || error.lastName || error.phoneNumber || contactMethod === '' ||
        ((contactMethod === 'both' || contactMethod === 'text') && ((!customerOptIn && props.textOptIn !== 'I') ||
            props.textOptIn === 'T')) || (services?.length === 0 && !props.skipServices && !skipServiceReason) ||
            (props.appointment.ApptVeh.mileage < props.prevMileage &&
                props.prevMileage > 0 && props.appointment.ApptVeh.mileage !== -1) || (firstName + lastName).length > 35;

    useEffect(() => {
        if (requiredInfoError) {
            setRequiredInfoCompleted(false);
        } else {
            setRequiredInfoCompleted(true);
        }
    }, [requiredInfoCompleted, requiredInfoError]);

    let tryAgainHandler = (e: any) => {
        props.clearError();
        props.clearCustError();
        if (!cancelPressed) {
            footerHandler(e);
        } else {
            CancelApptHandler();
        }
    };

    const continueHandler = () => {
        props.clearError();
        setCancelPressed(false);
    };

    const closeHandler = (e: any) => {
        if (props.custError === '1007' && initialEmail.current) {
            setEmail(initialEmail.current);
        }
        props.clearError();
        props.clearCustError();
        setShowCancelMsg(false);
        setCancelPressed(false);
        setShowTransRemoveWarning(false);
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'service',
            elementText: showTransRemoveWarning ? strings.Okay : strings.TryAgain,
            elementColor: '',
            elementOrder: '',
            elementType: 'popup',
            elementSubType: 'nav_button',
            eventAction: 'click',
            eventActionResult: 'close',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
    };

    const modifyAppointmentHandler = () => {
        let skipQuickTimes = true;
        if (props.specData?.deptSpecs?.recommTimes) {
            skipQuickTimes = false;
        }
        if (skipQuickTimes) {
            props.clearInvalidDates();
            props.pushToMainPanes({
                viewId: ComponentMapIds.CalendarSelect,
                component: ComponentMapIds.CalendarSelect,
            });
        } else {
            props.pushToMainPanes({
                viewId: ComponentMapIds.QuickTime,
                component: ComponentMapIds.QuickTime,
            });
        }

        if (props.appointment && isSDAnalyticsEnabled) {
            sendSdEvent('scheduleServiceReviewStart', buildApptData(props.sessionId,
                getProviderId(props.specData?.specs, props.toyotaMCLaunched, props.toyotaTDMCLaunched,
                    props.lexusMCLaunched, props.lexusTDMCLaunched), props.appointment));
        }
    };

    // Think we may need to make this a mod as old service portal did not allow changing the VIN
    // const modifyVehicleHandler = () => {
    //     // do stuff here
    //     props.pushToMainPanes({
    //         viewId: ComponentMapIds.VehSel,
    //         component: ComponentMapIds.VehSel,
    //     });
    // };

    const modifyServicesHandler = (e: any) => {
        // Check to see if we should go for Maintnenance Contracts
        const maintMake = props.selectedVehicle && props.selectedVehicle !== 'AddVehicle' ?
            props.appointment.ApptVeh.make.toLowerCase().split(' ')[0]:'';
            // locale
        // const maintContractView = (props.selectedVehicle && props.locale === 'en-US' &&
        const maintContractView = (props.selectedVehicle && props.countryCode === 'US' &&
            (((props.lexusMCLaunched || props.lexusTDMCLaunched) && maintMake==='lexus') ||
            ((props.toyotaMCLaunched || props.toyotaTDMCLaunched) && maintMake==='toyota')));
        if ((props.additionalServices.allServices.built || maintContractView) && props.viewMode === ViewMode.EditAppt) {
            // Go to the Addtional Services screen if there is data to display there
            // Other wise go to the ServiceTab
            let nextViewId = ComponentMapIds.AdditionalServices;
            let nextComponent = ComponentMapIds.AdditionalServices;
            if (!maintContractView && (!props.appointment.ApptVeh.vin ||
                (!props.specData?.specs?.showWeOwes && !props.specData?.specs?.showPrvRecom &&
                    (!props.specData?.specs?.showOEMRecall || !props.additionalServices.allServices.inquiryInvoked)))) {
                nextViewId = ComponentMapIds.ServiceTab;
                nextComponent = ComponentMapIds.ServiceTab;
            }
            if (!maintContractView && !props.additionalServices.allServices.weOwes[0] &&
                !props.additionalServices.allServices.recom[0] && !props.additionalServices.allServices.inquiryInvoked) {
                nextViewId = ComponentMapIds.ServiceTab;
                nextComponent = ComponentMapIds.ServiceTab;
            }

            const elementColor = getElementColor(e, 'color');
            const ascCtaInteractionInp : ascCtaInteractionInput = {
                pageType: 'service',
                elementText: strings.UpdateServices,
                elementColor: elementColor,
                elementOrder: '',
                elementType: 'item_details',
                elementSubType: 'other_buttons',
                eventAction: 'click',
                eventActionResult: 'next_step',
                linkUrl: '',
            };
            ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
            if (props.appointment && isSDAnalyticsEnabled) {
                sendSdEvent('scheduleServiceReviewStart', buildApptData(props.sessionId,
                    getProviderId(props.specData?.specs, props.toyotaMCLaunched, props.toyotaTDMCLaunched,
                        props.lexusMCLaunched, props.lexusTDMCLaunched), props.appointment));
            }

            props.pushToMainPanes({
                viewId: nextViewId,
                component: nextComponent,
            });
        }
    };

    if (!showCancelMsg && props.appointment.error?.errorCode === '0' && cancelPressed) {
        setCancellingAppointment(false);
        setCancelPressed(false);
        props.clearError();
        props.pushToMainPanes({
            viewId: ComponentMapIds.ThankYou,
            component: ComponentMapIds.ThankYou,
        });
    }

    const noServicesHandler = (e: any) => {
        if (props.specData?.specs?.skipServicesFlag) {
            const inp: UpdateApptDateInp = {
                selDate: '',
                selTime: '',
                selAdv: '',
                selTrans: '',
                selAdvName: '',
                selAdvImage: '',
                selTransFlag: '',
                selApptNum: '',
            };
            props.updateApptDate(inp);
            if (props.viewMode === ViewMode.Appt) {
                props.clearOnlyAppointmentState();
            }
            const defaultDept = {
                defaultDept: props.specData?.specs?.departmentFlag ?? '',
            };
            props.determineDept(defaultDept);
            props.getDeptSpecs();
            props.pushToMainPanes({
                viewId: ComponentMapIds.AddSkipServices,
                component: ComponentMapIds.AddSkipServices,
            });
        } else {
            // Check to see if we should go for Maintnenance Contracts
            const maintMake = props.selectedVehicle && props.selectedVehicle !== 'AddVehicle' ?
                props.appointment.ApptVeh.make.toLowerCase().split(' ')[0]:'';
                // locale
            // const maintContractView = (props.selectedVehicle && props.locale === 'en-US' &&
            const maintContractView = (props.selectedVehicle && props.countryCode === 'US' &&
                (((props.lexusMCLaunched || props.lexusTDMCLaunched) && maintMake==='lexus') ||
                ((props.toyotaMCLaunched || props.toyotaTDMCLaunched) && maintMake==='toyota')));
            let nextViewId = ComponentMapIds.AdditionalServices;
            let nextComponent = ComponentMapIds.AdditionalServices;
            if (!maintContractView && (!props.appointment.ApptVeh.vin ||
                (!props.specData?.specs?.showWeOwes && !props.specData?.specs?.showPrvRecom &&
                    (!props.specData?.specs?.showOEMRecall || !props.additionalServices.allServices.inquiryInvoked)))) {
                nextViewId = ComponentMapIds.ServiceTab;
                nextComponent = ComponentMapIds.ServiceTab;
            }
            if (!maintContractView && !props.additionalServices.allServices.weOwes[0] &&
                !props.additionalServices.allServices.recom[0] && !props.additionalServices.allServices.inquiryInvoked) {
                nextViewId = ComponentMapIds.ServiceTab;
                nextComponent = ComponentMapIds.ServiceTab;
            }

            props.clearCheckedWebOps();
            props.clearCheckedAdditionalServices();
            props.pushToMainPanes({
                viewId: nextViewId,
                component: nextComponent,
            });
        }
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'service',
            elementText: strings.NoServicesClickHere,
            elementColor: '',
            elementOrder: '',
            elementType: 'scheduling_tool',
            elementSubType: 'selection_link',
            eventAction: 'click',
            eventActionResult: 'next_step',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
        setHighlightNoServicesSelected(false);

        if (props.appointment && isSDAnalyticsEnabled) {
            sendSdEvent('scheduleServiceReviewStart', buildApptData(props.sessionId,
                getProviderId(props.specData?.specs, props.toyotaMCLaunched, props.toyotaTDMCLaunched,
                    props.lexusMCLaunched, props.lexusTDMCLaunched), props.appointment));
        }
    };

    const errorMessage = () => {
        // For now use the passed back error code and message, will need to create translated error messages dependent on the code
        if (!showCancelMsg && props.appointment.error?.errorCode !== '0' &&
            (props.appointment.error?.errorCode || props.appointment.error?.errorMsg)) {
            let headerMsg = strings.AppointmentError;
            let errorMsg: string | undefined = strings.AppointmentError +
                props.appointment.error?.errorCode + ' ' + props.appointment.error?.errorMsg;
            const primaryMessage = strings.TryAgain;
            const secondaryMessage = strings.Continue;
            // If record lock, then display special error message; guest or customer with an account
            if (props.appointment.error.errorCode === '3' ||
                props.appointment.error.errorCode === '500' ||
                props.appointment.error.errorCode === '14') {
                return <RecordLockError
                    headerMsg={strings.Oops}
                    // message={messageMode + strings.ApptTimeLit}
                    message={lockMsg + strings.ApptTimeLit}
                    primaryHandler={tryAgainHandler}
                    secondaryHandler={closeHandler}
                    closeHandler={closeHandler}
                />;
            }

            if (props.appointment.error.errorCode === '202') {
                headerMsg = strings.ApptUnavailable;
                errorMsg = strings.SelectNewAdv;

                tryAgainHandler = () => {
                    props.pushToMainPanes({
                        viewId: ComponentMapIds.CalendarSelect,
                        component: ComponentMapIds.CalendarSelect,
                    });
                    props.clearError();
                    props.clearCustError();
                };
            }

            return (
                <ErrorMessage
                    headerMsg={headerMsg}
                    errorMsg={errorMsg}
                    primaryBtnMessage={primaryMessage}
                    secondaryBtnMessage={secondaryMessage}
                    primaryHandler={tryAgainHandler}
                    secondaryHandler={continueHandler}
                    closeHandler={closeHandler}
                />
            );
        } else if (props.custError === '1007' && !props.profileOpen) {
            const headerMsg = strings.EmailUsed;
            const errorMsg = strings.formatString(strings.EmailUsedMsgNoSave, email).toString();
            const primaryMessage = strings.TryAgain;
            const secondaryMessage = strings.Cancel;

            return (
                <ErrorMessage
                    headerMsg={headerMsg}
                    errorMsg={errorMsg}
                    primaryBtnMessage={primaryMessage}
                    secondaryBtnMessage={secondaryMessage}
                    primaryHandler={tryAgainHandler}
                    secondaryHandler={closeHandler}
                    closeHandler={closeHandler}
                />
            );
        } else {
            return null;
        }
    };

    const errMessage = errorMessage();



    if (creatingAppointment && props.appointment.error) {
        if (props.appointment.error.errorCode !== '0' && (props.appointment.error.errorCode || props.appointment.error.errorMsg)) {
            setCreatingAppointment(false);
            const ascRetailProcessInp: ascRetailProcessInput = {
                pageType: 'service',
                flowStage: '6b',
                flowOutcome: 'error',
                flowName: 'appointment',
                elementTitle: 'Add Appointment',
            };
            ascRetailProcess(ascRetailProcessInp, props.vehicles, props.selectedVehicle);
        } else {
            setCreatingAppointment(false);
            props.clearError();
            if (props.appointment.ApptCust.custNameId) {
                // Update the customer's appointment list
                props.getCustAppts(props.appointment.ApptCust.custNameId, props.profile, props.store, props.branch);
            }
            props.clearCheckedWebOps();
            props.clearCheckedAdditionalServices();
            const ascRetailProcessInp: ascRetailProcessInput = {
                pageType: 'service',
                flowStage: '6a',
                flowOutcome: 'lead',
                flowName: 'appointment',
                elementTitle: 'Add Appointment',
            };
            ascRetailProcess(ascRetailProcessInp, props.vehicles, props.selectedVehicle);
            setSendGA4(true);

            props.pushToMainPanes({
                viewId: ComponentMapIds.Confirmation,
                component: ComponentMapIds.Confirmation,
            });

            setSendSD(true);
        }
    }

    useEffect(() => {
        if (!sendSD) {
            return;
        }
        setSendSD(false);

        if (props.viewMode === ViewMode.Appt) {
            if (props.appointment && isSDAnalyticsEnabled && props.specData?.specs?.vwTrackingFlag !== 'Y') {
                sendSdEvent('scheduleServiceApptSet', buildApptData(props.sessionId,
                    getProviderId(props.specData?.specs, props.toyotaMCLaunched, props.toyotaTDMCLaunched,
                        props.lexusMCLaunched, props.lexusTDMCLaunched), props.appointment));
                sendSdEvent('scheduleServiceFormFinish', buildApptData(props.sessionId,
                    getProviderId(props.specData?.specs, props.toyotaMCLaunched, props.toyotaTDMCLaunched,
                        props.lexusMCLaunched, props.lexusTDMCLaunched), props.appointment));
            }

            const sdServices = props.appointment.ApptOps.map(op => {
                let opPrice = '';
                if (op.itemCostHigh && op.itemCostHigh !== '****') {
                    opPrice = op.itemCostHigh;
                } else if (op.itemCostLow && op.itemCostLow !== '****') {
                    opPrice = op.itemCostLow;
                }

                return {
                    msrp: opPrice,
                };
            });
            const totalMSRP = sdServices.reduce(
                (acc, svc) => acc + (Number(svc.msrp) || 0),
                0,
            );
            props.addLogEntry('Total MSRP', 'Summary', 'TotalMSRP=' + String(totalMSRP));
        }
    }, [props.addLogEntry, props.appointment, creatingAppointment, props.viewMode, sendSD, props.sessionId,
        props.specData, props.toyotaMCLaunched, props.toyotaTDMCLaunched, props.lexusMCLaunched,
        props.lexusTDMCLaunched, isSDAnalyticsEnabled, props.vwTrackingFlag]);

    useEffect(() => {
        if (sendGA4) {
            setSendGA4(false);

            const ascFormSubmissionInp: ascFormSubmissionInput = {
                pageType: 'service',
                commType: 'form',
                commOutcome: 'appt_set',
                submissionId: props.customerInfo.ascCustId ?? '',
                elementText: primaryMsg,
                department: 'service',
                formName: 'Service_Portal_2',
                formType: 'service_appointment',
            };
            ascFormSubmission(ascFormSubmissionInp, props.vehicles, props.selectedVehicle);

            const ascFormSubmissionSvcApptInp : ascFormSubmissionSvcApptInput = {
                pageType: 'service',
                commType: 'form',
                commOutcome: 'appt_set',
                submissionId: props.appointment.Appointment?.apptNum ?? '',
                elementText: primaryMsg,
                department: 'service',
                formName: 'Service_Portal_2',
                formType: 'service_appointment',
            };
            ascFormSubmissionSvcAppt(ascFormSubmissionSvcApptInp, props.vehicles, props.selectedVehicle);
        }
    }, [primaryMsg, props.appointment.Appointment?.apptNum, props.customerInfo.ascCustId, props.selectedVehicle,
        props.vehicles, sendGA4]);

    const CancelApptHandler = () => {
        setLockMsg(strings.Cancelling);
        props.cancelAppt();
        setShowCancelMsg(false);
        setCancellingAppointment(true);
        setCancelPressed(true);
    };

    if (cancellingAppointment && props.appointment.error) {
        if (props.appointment.error.errorCode !== '0' && (props.appointment.error.errorCode || props.appointment.error.errorMsg)) {
            setCancellingAppointment(false);
        } else {
            setCancellingAppointment(false);
            setCancelPressed(false);
            props.clearError();
            props.pushToMainPanes({
                viewId: ComponentMapIds.ThankYou,
                component: ComponentMapIds.ThankYou,
            });
            setApptMileage(0);
            const updateApptInp = {
                vin: '',
                makeCode: '',
                make: '',
                model: '',
                series: '',
                vehYr: '',
                vehColor: '',
                mileage: 0,
                imagePath: '',
            };
            props.updateApptVeh(updateApptInp);
        }
    }

    const cancelErrMessage = () => {
        if (showCancelMsg) {
            const headerMsg = strings.CancelAppt;
            const errorMsg = strings.AreYouSure;
            const primaryMessage = strings.CancelAppt;
            const secondaryMessage = strings.GoBack;

            return (
                <ErrorMessage
                    headerMsg={headerMsg}
                    errorMsg={errorMsg}
                    primaryBtnMessage={primaryMessage}
                    secondaryBtnMessage={secondaryMessage}
                    primaryHandler={CancelApptHandler}
                    secondaryHandler={closeHandler}
                    closeHandler={closeHandler}
                />
            );
        } else {
            return null;
        }
    };

    const cancelMessage = cancelErrMessage();
    const cancelHandler = (e: any) => {
        setShowCancelMsg(true);
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'service',
            elementText: secondaryMessage,
            elementColor: '',
            elementOrder: '',
            elementType: 'footer',
            elementSubType: 'nav_button',
            eventAction: 'click',
            eventActionResult: 'next_step',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);

        if (props.appointment && isSDAnalyticsEnabled) {
            sendSdEvent('scheduleServiceReviewStart', buildApptData(props.sessionId,
                getProviderId(props.specData?.specs, props.toyotaMCLaunched, props.toyotaTDMCLaunched,
                    props.lexusMCLaunched, props.lexusTDMCLaunched), props.appointment));
        }
    };

    const transRemoveErrMessage = () => {
        if (showTransRemoveWarning) {
            const headerMsg = '';
            const errorMsg = strings.formatString(
                strings.TransRemoveWarnMsg, props.appointment.Appointment.trans).toString();
            const primaryMessage = strings.Okay;
            const secondaryMessage = '';

            return (
                <ErrorMessage
                    headerMsg={headerMsg}
                    errorMsg={errorMsg}
                    primaryBtnMessage={primaryMessage}
                    secondaryBtnMessage={secondaryMessage}
                    primaryHandler={closeHandler}
                    secondaryHandler={closeHandler}
                    closeHandler={closeHandler}
                />
            );
        } else {
            return null;
        }
    };

    const transRemoveMessage = transRemoveErrMessage();

    // Set the "Let's review" string based on the current ViewMode
    let letsReviewLit = strings.LetsReviewAdd;
    if (props.viewMode === ViewMode.EditAppt) {
        letsReviewLit = strings.LetsReviewModify;
    }

    // Get the Transportation state to display the transportation title on the appointment card.
    const transportation = props.appointment.Appointment.transFlag;
    const transIndex = props.specData?.deptSpecs?.Transportation.find(trans => trans.type === transportation);

    const changeHandler = (id: string, value: string) => {
        if (props.appointment && isSDAnalyticsEnabled) {
            sendSdEvent('scheduleServiceFormStart', buildApptData(props.sessionId,
                getProviderId(props.specData?.specs, props.toyotaMCLaunched, props.toyotaTDMCLaunched,
                    props.lexusMCLaunched, props.lexusTDMCLaunched), props.appointment));

            sendSdEvent('scheduleServiceReviewStart', buildApptData(props.sessionId,
                getProviderId(props.specData?.specs, props.toyotaMCLaunched, props.toyotaTDMCLaunched,
                    props.lexusMCLaunched, props.lexusTDMCLaunched), props.appointment));
        }
        switch (id) {
            case 'firstName':
                setFirstChanged(true);
                nameChangeHandler(id, value);
                break;
            case 'lastName':
                setLastChanged(true);
                nameChangeHandler(id, value);
                break;
            case 'phoneNumber':
                setPhoneChanged(true);
                phoneNumberChangedHandler(id, value);
                break;
            case 'emailAddress':
                setEmailChanged(true);
                emailChangedHandler(id, value);
                break;
            default:
                break;
        }
    };

    /** Navigates to identity verification when the user taps Edit on the information card. */
    const editHandler = (e: any) => {
        props.pushToMainPanes({viewId: ComponentMapIds.VerifyIdentity, component: ComponentMapIds.VerifyIdentity});
        const elementColor = getElementColor(e, 'color');
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'service',
            elementText: strings.Edit,
            elementColor: elementColor,
            elementOrder: '',
            elementType: 'form',
            elementSubType: 'other_buttons',
            eventAction: 'click',
            eventActionResult: 'next_step',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
        const ascFormEngagementInp: ascFormEngagementInput = {
            pageType: 'service',
            commType: 'form',
            commStatus: 'engage',
            elementText: strings.Edit,
            department: 'service',
            formName: 'Service_Portal_2',
            formType: 'service_appointment',
        };
        ascFormEngagement(ascFormEngagementInp, props.vehicles, props.selectedVehicle);
        sendSdEvent('scheduleServiceFormStart', buildApptData(props.sessionId,
            getProviderId(props.specData?.specs, props.toyotaMCLaunched, props.toyotaTDMCLaunched,
                props.lexusMCLaunched, props.lexusTDMCLaunched),
            props.appointment),
        );
    };

    const blurHandler = (id) => {
        let elementText = '';
        switch (id) {
            case 'firstName':
                updateApptCustHandler('firstName', firstName);
                elementText = strings.FirstName;
                break;
            case 'lastName':
                updateApptCustHandler('lastName', lastName);
                elementText = strings.LastName;
                break;
            case 'phoneNumber':
                updateApptCustHandler('phoneNumber', phoneNumber);
                elementText = strings.Phone;
                break;
            case 'emailAddress':
                updateApptCustHandler('emailAddress', email);
                elementText = strings.EmailAddress;
                break;
            default:
                break;
        }

        const ascFormEngagementInp: ascFormEngagementInput = {
            pageType: 'service',
            commType: 'form',
            commStatus: 'engage',
            elementText: elementText,
            department: 'service',
            formName: 'Service_Portal_2',
            formType: 'service_appointment',
        };
        ascFormEngagement(ascFormEngagementInp, props.vehicles, props.selectedVehicle);
    };

    const deptChangeCloseHandler = useCallback((e: any, elementText: string) => {
        setDisplayDeptChangeMessage(false);
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'service',
            elementText: elementText,
            elementColor: '',
            elementOrder: '',
            elementType: 'service',
            elementSubType: 'nav_button',
            eventAction: 'click',
            eventActionResult: 'close',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
    }, [props.selectedVehicle, props.vehicles]);

    const recomTimes = useMemo (() => (
        {
            'S': props.specData?.specs?.svcSpecs?.recommTimes,
            'B': props.specData?.specs?.bdySpecs?.recommTimes,
            'Q': props.specData?.specs?.ossSpecs?.recommTimes,
        }
    ), [props.specData?.specs?.svcSpecs?.recommTimes,
        props.specData?.specs?.bdySpecs?.recommTimes,
        props.specData?.specs?.ossSpecs?.recommTimes]);

    const deptChangeContinueHandler = (e: any) => {
        props.changeDeptFlag(true);
        setDisplayDeptChangeMessage(false);
        // Remove the service from the appointment.
        const defaultDept = {
            defaultDept: props.specData?.specs?.departmentFlag ?? '',
        };
        if (heldServices) {
            removeApptOps(heldServices);
        }
        props.determineDept(defaultDept);
        setServices(heldServices);
        props.getApptOps(props.specProfile, props.store, props.branch);
        setHeldServices([]);
        props.getDeptSpecs();
        // If the current advisor is setup on the new department, there is no need to clear the advisor.
        let advisorChangeNeeded = true;
        let apptDeptAdvisors : Advisor[] = [];
        switch (newDept) {
            case 'B':
                apptDeptAdvisors = props.specData!.specs!.bdySpecs!.Advisors;
                break;
            case 'P':
                apptDeptAdvisors = props.specData!.specs!.pdiSpecs!.Advisors;
                break;
            case 'Q':
                apptDeptAdvisors = props.specData!.specs!.ossSpecs!.Advisors;
                break;
            default:
                apptDeptAdvisors = props.specData!.specs!.svcSpecs!.Advisors;
                break;
        }
        apptDeptAdvisors.forEach((advisor) => {
            if (advisor.advisorNum === props.apptAdvNum) {
                advisorChangeNeeded = false;
            }
        });
        if (advisorChangeNeeded) {
            const inp: UpdateApptDateInp = {
                selDate: '',
                selTime: '',
                selAdv: '',
                selTrans: '',
                selAdvName: '',
                selAdvImage: '',
                selTransFlag: '',
                selApptNum: '',
            };
            props.updateApptDate(inp);
            props.clearInvalidDates();
            props.clearRMTimes();
            // We need to pop the Summary pane before selecting a new date/time.
            const mainViewPanes = props.mainPaneViewOrder.map((view): IView => ({ ...view }));
            // This is the screen the user is on.
            const currentViewPanes = mainViewPanes[mainViewPanes.length - 1];
            props.popFromMainPane(currentViewPanes.viewId);
            // Determine if we should move to QuickTime or CalendarSelect
            let skipQuickTimes = true;
            if (recomTimes[newDept] === 'Y' && props.apptCust?.custFirstName !== '' &&
                props.apptCust?.custNameId !== '') {
                skipQuickTimes = false;
            }
            if (skipQuickTimes) {
                let checkDate = '';
                if (props.invalidDates[0]) {
                    checkDate = props.invalidDates[0].date;
                }
                if (checkDate === '00/00/00') {
                    props.pushToMainPanes({
                        viewId: ComponentMapIds.CalendarSelect,
                        component: ComponentMapIds.CalendarSelect,
                    });
                }
            } else {
                props.pushToMainPanes({
                    viewId: ComponentMapIds.QuickTime,
                    component: ComponentMapIds.QuickTime,
                });
            }
        }
        // Reset the previous department.
        setPrevDept(props.apptDept);
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'service',
            elementText: strings.Continue,
            elementColor: '',
            elementOrder: '',
            elementType: 'service',
            elementSubType: 'nav_button',
            eventAction: 'click',
            eventActionResult: 'close',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
    };

    // If department on the appointment changes, update prevDept
    useEffect(() => {
        setPrevDept(props.appointment.Appointment.department);
    }, [props.appointment.Appointment.department]);

    const deptChangeErrMessage = () => {
        if (displayDeptChangeMessage) {
            const headerMsg = strings.DeptChangeWarning;
            const errorMsg = strings.DeptChangeMessage;
            const primaryMessage = strings.Continue;
            const secondaryMessage = strings.Cancel;
            const ascPageViewInp: ascPageviewInput = {
                pageType: 'service',
                errorCode: '',
                itemResults: '',
            };
            ascPageview(ascPageViewInp, props.vehicles, props.selectedVehicle);

            return (
                <ErrorMessage
                    headerMsg={headerMsg}
                    errorMsg={errorMsg}
                    primaryBtnMessage={primaryMessage}
                    secondaryBtnMessage={secondaryMessage}
                    primaryHandler={deptChangeContinueHandler}
                    secondaryHandler={(e: any) => deptChangeCloseHandler(e, strings.Cancel)}
                    closeHandler={(e: any) => deptChangeCloseHandler(e, '')}
                />
            );
        } else {
            return null;
        }
    };

    const deptChangeMessage = deptChangeErrMessage();

    let formattedPhone = phoneNumber;
    const phoneMatch = phoneNumber?.match(phoneRegex) ? phoneNumber?.match(phoneRegex) : false;

    if (phoneMatch) {
        formattedPhone = `(${phoneMatch[1]}) ${phoneMatch[2]}-${phoneMatch[3]}`;
    }

    useEffect(() => {
        if (props.identityVerified && !identVerifyUpdt) {
            setIdentVerifyUpdt(true);
            const apptCustInp: UpdateApptCustInp = {
                nameId: props.appointment.ApptCust.custNameId,
                firstName: props.customerInfo.firstName,
                lastName: props.customerInfo.lastName,
                emailAddress: props.customerInfo.emailAddress,
                phoneNumber: props.customerInfo.phoneNumber,
                phoneType: props.appointment.ApptCust.custPhoneType,
                prefContact: props.appointment.ApptCust.custPrefContact,
                loggedIn: props.appointment.ApptCust.custLoggedIn,
            };
            props.onApptCustUpdate(apptCustInp);
        }
    }, [props.appointment.ApptCust, props.customerInfo, props.identityVerified, props.onApptCustUpdate, identVerifyUpdt]);

    useEffect(() => {
        // If the department changes, we may need to change a few values.
        // Check whether consent is required and the consent message.
        if (props.specData?.deptSpecs?.requireConsFlg) {
            setRequireConsent(true);
        } else {
            setRequireConsent(false);
        }
        setRequireConsentMessage(props.specData?.deptSpecs?.requireConsMsg ?? '');
        // Check if the department allows for changing an email address.
        setCustEmailUpdate(checkCustUpdateEmail(props.appointment?.Appointment.department, props.specData?.specs) ||
        !props.customerInfo?.emailAddress);
        // Change the Disclaimer Message.
        setDisclaimerMessage(props.specData?.deptSpecs?.disclaimerMsg ?? '');
    }, [props.specData?.deptSpecs?.requireConsFlg, props.specData, props.apptDept,
        props.appointment?.Appointment.department, props.customerInfo?.emailAddress, custEmailUpdate]);

    useEffect(() => {
        props.addLogEntry('Screen Entry', 'Summary', '');
    }, [
        props.addLogEntry,
    ]);

    const summaryTitleStyles = classNames(
        cssCards.summaryTitle,
        {
            [cssCards.fontWeightHeadingTextWeight]: props.theme === 'bmw' || props.theme === 'honda' || props.theme === 'ford',
            [cssCards.summaryTitleIN]: props.theme === 'infiniti',
            [cssCards.summaryTitleMazda]: props.theme === 'mazda',
            [cssCards.summaryTitleAcura]: props.theme === 'acura',
            [cssCards.summaryTitleGenesis]: props.theme === 'genesis',
            [cssCards.summaryTitleLexus]: props.theme === 'lexus',
        },
    );

    const NameStyles = classNames(
        css.Name,
        {
            [css.NameBMW]: props.theme === 'bmw',
            [css.NameMazda]: props.theme === 'mazda',
            [css.NameGenesis]: props.theme === 'genesis',
            [css.NameLexus]: props.theme === 'lexus',
        },
    );

    return (
        <div>
            {deptChangeMessage}
            <div className={mainDiv}>
                <ScrollBar scrollVertical>
                    <div className={css.secDiv}>
                        {(creatingAppointment || loadingOps || cancellingAppointment || props.gmRewardsLoading) ?
                            <LoadingProgress cssClasses={{ spinner: css.progressColor }} size={100} /> : null}
                        {errMessage}
                        {cancelMessage}
                        {transRemoveMessage}
                        {deptChangeMessage}
                        <h2 className={NameStyles}>
                            {props.identityVerified ?
                                props.appointment.ApptCust.custFirstName + ',' :
                                strings.WelcomeBack}
                        </h2>
                        <h3>{letsReviewLit}</h3>
                        <h3>{strings.RequiredFields}</h3>
                        <hr className={css.summaryHr}/>
                        <div className={css.flexBox}>
                            <div className={css.secondRow}>
                                <div className={css.apptCardDiv}>
                                    <AppointmentCard
                                        appointment={props.appointment.Appointment}
                                        transIndex={transIndex}
                                        advisorPhotoPath={props.appointment.Appointment.advImage}
                                        advImgAltTag={AdvImgAltTag}
                                        viewMode={props.viewMode}
                                        theme={props.theme}
                                        locale={props.locale}
                                        modifyAppointment={modifyAppointmentHandler}
                                    />
                                </div>
                                <div className={css.vehCardDiv}>
                                    <h4 className={summaryTitleStyles}>
                                        {strings.Vehicle}
                                    </h4>
                                    <VehicleCard
                                        vehicle={vehicle}
                                        updateMileageState={changePrevMileage}
                                        summary
                                        vehPhotoList={props.vehPhotoList}
                                        theme={props.theme}
                                        newVehicleMileage={props.newVehicleMileage}
                                        prevMileage={props.prevMileage}
                                        apptMileage={apptMileage}
                                        TMNAMileage={props.TMNAMileage}
                                        cancellingAppointment={cancellingAppointment}
                                        Itype={props.Itype}
                                        getFieldRef={(el) => (mileageRef.current = el)}
                                        specData={props.specData?.specs}
                                        sessionId = {props.sessionId}
                                        lexusMCLaunched = {props.lexusMCLaunched}
                                        lexusTDMCLaunched = {props.lexusTDMCLaunched}
                                        toyotaMCLaunched = {props.toyotaMCLaunched}
                                        toyotaTDMCLaunched = {props.toyotaTDMCLaunched}
                                        appointment = {props.appointment}
                                    />
                                </div>
                            </div>
                            <div className={css.secondRow}>
                                <InformationCard
                                    theme={props.theme}
                                    onEdit={editHandler}
                                    nameId={props.customerInfo.nameId}
                                    identityVerified={props.identityVerified}
                                    selectedVehicle={props.selectedVehicle}
                                >
                                    <InformationCardField
                                        id='firstName'
                                        label={strings.FirstNameLabel}
                                        value={firstName}
                                        error={error.firstName || (firstName + lastName).length > 35}
                                        onChange={changeHandler}
                                        onBlur={blurHandler}
                                        disabled={forceVerifyIdentity}
                                        getFieldRef={(el) => (firstNameRef.current = el)}
                                        theme={props.theme}
                                    />
                                    <InformationCardField
                                        id='lastName'
                                        label={strings.LastNameLabel}
                                        value={lastName}
                                        error={error.lastName || (firstName + lastName).length > 35}
                                        onChange={changeHandler}
                                        onBlur={blurHandler}
                                        disabled={forceVerifyIdentity}
                                        getFieldRef={(el) => (lastNameRef.current = el)}
                                        theme={props.theme}
                                    />
                                    <InformationCardField
                                        id='phoneNumber'
                                        label={strings.PhoneLabel}
                                        value={formattedPhone}
                                        error={error.phoneNumber}
                                        onChange={changeHandler}
                                        onBlur={blurHandler}
                                        disabled={forceVerifyIdentity}
                                        getFieldRef={(el) => (phoneRef.current = el)}
                                        theme={props.theme}
                                    />
                                    <InformationCardField
                                        id='emailAddress'
                                        label={strings.Email}
                                        value={email}
                                        error={error.emailAddress}
                                        onChange={changeHandler}
                                        onBlur={blurHandler}
                                        disabled={!custEmailUpdate || (forceVerifyIdentity)}
                                        getFieldRef={(el) => (emailRef.current = el)}
                                        theme={props.theme}
                                    />
                                </InformationCard>
                                {services && !(props.skipServices) ? <ServicesCard
                                    services={services}
                                    removeService={removeService}
                                    totalMinCost={totalMinCost}
                                    myCart={false}
                                    skipServiceReason={skipServiceReason}
                                    modifyServices={modifyServicesHandler}
                                    noServicesSelected={noServicesHandler}
                                    viewMode={props.viewMode}
                                    theme={props.theme}
                                    currentMainPane=''
                                    displayMCMessage={displayMCMessage}
                                    gmRedeemAmt={props.gmRedeemAmt}
                                    gmDealerCanEarn={props.gmDealerCanEarn}
                                    gmDealerCanRedeem={props.gmDealerCanRedeem}
                                    highlightNoServicesSelected={highlightNoServicesSelected}
                                    hidePriceLabel={props.hidePriceLabel}
                                /> : null}
                            </div>
                        </div>
                        <h4 className={summaryTitleStyles}>
                            {strings.Confirmation}
                        </h4>
                        <div className={(props.theme === 'lexusMonogram' || props.theme === 'colorSensitive') ? css.borderLM :
                            undefined}>
                            <ConfirmationCard
                                contactMethod={contactMethod}
                                changeContactMethodHandler={changeContactMethodHandler}
                                makePreferredContact={makePreferredContact}
                                toggleMakePreferredContact={toggleMakePreferredContact}
                                preferContactSelect={preferContactSelect}
                                setPreferContactSelect={setPreferContactSelect}
                                customerOptedIn={props.textOptIn}
                                dialogActive={dialogActive}
                                closeDialog={closeDialog}
                                buttonsHandler={buttonsHandler}
                                customerName={props.identityVerified ?
                                    props.appointment.ApptCust.custFirstName :
                                    strings.WelcomeBack}
                                textOptInMsg={props.specData?.specs?.textOptInMsg ?? ''}
                                dealershipName={props.specData?.specs?.mobileName ?? ''}
                                dealershipPhone={props.specData?.deptSpecs?.contactPhnNum ?? ''}
                                dealershipLongCode={props.specData?.specs?.longCode ?? ''}
                                textCheckReturned={props.textCheckReturned}
                                smsLaunched={props.smsLaunched ? props.smsLaunched:''}
                                theme={props.theme}
                                dealershipExt = {props.specData?.specs?.svcSpecs?.contactExt}
                                clearTextCheckReturned = {props.clearTextCheckReturned}
                                onPreferBothContactMethodChange={handlePreferBothContactMethodChange}
                                vehicles={props.vehicles}
                                selectedVehicle={props.selectedVehicle}
                                locale={props.locale}
                                countryCode={props.countryCode}
                                highlightSendConfirm={highlightSendConfirm}
                                appointment={props.appointment}
                                specData={props.specData?.specs}
                                sessionId={props.sessionId}
                                lexusMCLaunched={props.lexusMCLaunched}
                                toyotaMCLaunched={props.toyotaMCLaunched}
                                lexusTDMCLaunched={props.lexusTDMCLaunched}
                                toyotaTDMCLaunched={props.toyotaTDMCLaunched}
                            />
                            <Disclaimer
                                disclaimer={disclaimerMessage}
                                disclaimerChecked={disclaimerChecked}
                                toggleDisclaimerCheck={toggleDisclaimerCheck}
                                requireConsent={requireConsent}
                                requireConsentMsg={requireConsentMessage}
                                disclaimerMissing={disclaimerMissing}
                                theme={props.theme}
                            />
                        </div>
                    </div>
                </ScrollBar>
            </div>
            <div>
                <Footer
                    id='SummaryFooter'
                    handler={footerHandler}
                    message={primaryMsg}
                    secondaryMessage={secondaryMessage}
                    secondaryhandler={cancelHandler}
                    theme={props.theme}
                />
            </div >
        </div>
    );
};

export default Summary;
